<div mat-dialog-title>
  <h1 class="titulo-simpli animate__animated animate__fadeIn" style="position: relative;">{{ title }}</h1>
  <small class="subtitulo-simpli animate__animated animate__fadeIn">{{subtitle}}</small>
</div>

<div mat-dialog-content>
  <div class="row" style="position: relative">

    @if (disabled) {
      <div class="velo-inactivo animate__animated animate__fadeIn">
        @if (disabled) {
          <mat-spinner class="spinner-simpli" style="margin-top: 200px" diameter="40"></mat-spinner>
        }
      </div>
    }

    @if (hay_facturas_con_error) {
      <div class="col-lg-12 col-top">
        <div class="warning-msg" style="background-color: transparent !important;">
          <span class="material-symbols-outlined" style="color:#ff933b;">error</span>
          &nbsp; {{ mensaje_error }}
        </div>
      </div>
    }

    @if (todas_las_facturas_ok) {
      <div class="col-lg-12 col-top">
        <div class="success-msg" style="background-color: transparent !important;">
          <span class="material-symbols-outlined" style="color:#36a03f;">check_circle</span>
          &nbsp; ¡Proceso exitoso!
        </div>
      </div>
    }

    @if (show_descargar_plantilla) {
      <div class="col-lg-12 col-md-12 col-xs-12 col-top">
        <button (click)="descargar_file()" mat-stroked-button class="stroked-btn "
        style="width: 100%; margin-left: 0px !important;" color="primary">Descarga plantilla</button>
      </div>
    }


    <div class="container__drag">

      @if (!process) {
        <div class="row btn-carga-manual center__items flex__columns" (dragover)="onDragOver($event)" (drop)="onDropSuccess($event)">
          <input id="file_but" (change)="onChange($event)"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            type="file" style="display:none;" />
          <div >
            <h3>Arrastra plantilla aquí o</h3>
          </div>
          <div >
            <button (click)="subir()" mat-stroked-button class="stroked-btn" color="primary">Subir plantilla</button>
          </div>
        </div>
      }

      <ng-container>
        @if (process) {
          <div class="row">
            <div class="col-lg-12 justify-content-center">
              <mat-spinner class="spinner-simpli" style="margin-top: 200px" diameter="40"></mat-spinner>
            </div>
          </div>
        }
      </ng-container>

    </div>


  </div>
</div>

<div mat-dialog-actions>
  <button mat-stroked-button class="stroked-btn" mat-dialog-close>Cerrar</button>
  <button mat-stroked-button class="stroked-btn" color="primary" [mat-dialog-close]="colaboradores" (click)="crearNomina()"
  [disabled]="disabled_button">{{label_boton_financiar}}</button>
</div>
